module.exports = __webpack_public_path__ + "static/img/content13.e847d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/content13.png
// module id = xVoT
// module chunks = 1 3